import React from 'react';
import { Link as MuiLink } from '@mui/material';

type Props = {
  onManage: () => void;
};

/** Link no rodapé da página do evento (só quando há pixel ativo). */
const MetaConsentManageLink: React.FC<Props> = ({ onManage }) => (
  <MuiLink
    component="button"
    type="button"
    variant="body2"
    onClick={onManage}
    sx={{ cursor: 'pointer', color: 'text.secondary' }}
  >
    Gerenciar cookies
  </MuiLink>
);

export default MetaConsentManageLink;
